import { render, staticRenderFns } from "./networkingWidgetV2.vue?vue&type=template&id=580d0635&v-if=networkingActive"
import script from "./networkingWidgetV2.vue?vue&type=script&lang=js"
export * from "./networkingWidgetV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports